/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTipDeclarationSettings} from '../api'

 export const useQueryGetTipDeclarationSettings = createReactQueryHook('getTipDeclarationSettings', getTipDeclarationSettings)
